import type { PublicListingDto } from 'shared';
import { ListingCard } from './ListingCard.js';

/**
 * Horizontal-scroll row of listing cards, per the reference screenshot.
 * Only ever rendered by PublicHomepage.tsx when there's at least one
 * listing — the empty case is handled there, by not rendering the
 * surrounding section at all, so this component has nothing to render for
 * a zero-length list.
 */
export function ListingRow({ listings }: { listings: PublicListingDto[] }) {
  return (
    <div className="listing-row">
      {listings.map((listing) => (
        <ListingCard key={listing.id} listing={listing} />
      ))}
    </div>
  );
}
